export const DOCUMENT_TYPE_CAB_FLOOR_MAT_STANDARD_SETTINGS = 'commerce.cabFloorMatStandardSettings';
export const DOCUMENT_TYPE_CAB_FLOOR_MAT_PRODUCT = 'commerce.cabFloorMatProduct';
export const OBJECT_TYPE_CAB_FLOOR_MAT_MATERIAL = 'commerce.cabFloorMatMaterial';
/** @deprecated */
export const OBJECT_TYPE_CAB_FLOOR_MAT_VARIANT = 'commerce.cabFloorMatVariant';
export const OBJECT_TYPE_CAB_FLOOR_MAT_PRODUCT_IMAGE_SETTINGS =
	'commerce.cabFloorMatProductImageSettings';
